import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

import { newsRequestCompleted } from '../actions';

const { takeEvery, put } = sagaEffects;

function* handler() {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    try {
        yield firestore.get({
            collection: `languages/${config.app.defaultLanguage}/news`,
            storeAs: config.collections.news,
            orderBy: ['time', 'desc'],
        });
        yield firestore.get({
            collection: `languages/${config.app.defaultLanguage}/newsDelayed`,
            storeAs: config.collections.newsDelayed,
            orderBy: ['time', 'desc'],
        });
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.news.list' }));
    } finally {
        yield put(newsRequestCompleted());
    }
}

export default function* () {
    yield takeEvery(types.NEWS_REQUEST, handler);
}
